import $ from 'jquery';

$(() => {
  const selectizeSelects = $('.selectize');
  if (selectizeSelects.length) {
    selectizeSelects.each(function () {
      const select = $(this);
      const options: Selectize.IOptions<any, any> = {};
      if (select.data('create')) {
        options.create = true;
        if (select.data('create') == 'blur') {
          options.createOnBlur = true;
        }
      }
      // keeps an empty-valued option such as "all" selectable, which selectize drops by default
      if (select.data('allowEmptyOption')) {
        options.allowEmptyOption = true;
      }
      if (select.data('sortField')) {
        options.sortField = select.data('sortField');
      }
      select.selectize(options);
    });
  }
});
